import { SavingType } from "../savingTypes";
import BgIndonesia from "../../../assets/images/bg-indonesia.svg";
import {
  ClipboardIcon,
  ClipboardroundIcon,
  DesktopSavingIcon,
  ReversalIcon,
  SaldoIcon,
  SaldoroundIcon,
  SavingIcon,
  SwitchIcon,
  TotalIcon,
  TotalroundIcon,
  TransferIcon,
  TransferroundIcon,
} from "../icons";
import { Briefcase, Eye, EyeOff } from "lucide-react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

type BalanceCardProps = {
  data: SavingType;
  onClick: () => void;
  isActive?: boolean;
  activeUser: any;
  hasBorder?: boolean;
};

const icon = {
  total: TotalIcon,
  totalround: TotalroundIcon,
  transfer: TransferIcon,
  transferround: TransferroundIcon,
  saldo: SaldoIcon,
  saldoround: SaldoroundIcon,
  clipboard: ClipboardIcon,
  clipboardround: ClipboardroundIcon,
} as const;

export const BalanceCard = ({
  data,
  onClick,
  isActive,
  activeUser,
  hasBorder = false,
}: BalanceCardProps) => {
  const navigate = useNavigate();
  const [showBalance, setShowBalance] = useState(false);

  // Helper untuk format currency IDR
  const formatCurrency = (amount: string) => {
    return new Intl.NumberFormat("id-ID").format(Number(amount));
  };

  return (
    <div
      className={`relative overflow-hidden bg-white p-3 rounded-xl ${isActive && "border-2 border-blue-600"} ${hasBorder ? "border-1" : ""} shadow-sm cursor-pointer min-h-[160px] max-h-[160px] flex flex-col justify-between`}
      onClick={onClick}
    >
      {/* Background Map Indonesia */}
      <img
        src={BgIndonesia}
        alt="Background"
        className="absolute bottom-0 right-0 w-3/4 h-auto object-contain opacity-80 pointer-events-none"
      />

      {/* Header Section */}
      <div className="relative z-10 flex justify-between items-start">
        <h3 className="text-slate-500 text-xs font-medium">
          {data.savingName}
        </h3>

        {/* Icon Kanan Atas */}
        <div className="bg-blue-100 p-2 rounded-full">
          <TotalIcon className="w-6 h-6" />
        </div>
      </div>

      {/* Balance Section */}
      <div className="relative z-10 flex items-center gap-3">
        <span className="text-lg font-bold text-slate-800">
          Rp.{showBalance ? formatCurrency(data.balance) : "***********"}
        </span>
        <button
          onClick={(e) => {
            e.stopPropagation(); // Agar tidak mentrigger onClick milik parent card
            setShowBalance(!showBalance);
          }}
          className="p-1 hover:bg-slate-100 rounded-full transition-colors"
        >
          {showBalance ? (
            <EyeOff className="w-6 h-6 text-slate-800" />
          ) : (
            <Eye className="w-6 h-6 text-slate-800" />
          )}
        </button>
      </div>

      {/* Footer / Button Section */}
      <div className="relative z-10 mt-4">
        <button
          className="bg-blue-600 text-white px-6 py-2 text-sm rounded-full font-semibold hover:bg-blue-700 transition-colors"
          onClick={() => {
            navigate("/saving/create", {
              state: {
                savingAccount: data,
                activeUser,
              },
            });
          }}
        >
          Yuk Nabung
        </button>
      </div>
    </div>
  );
};
